import React, {useState} from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import EmailManager from "../components/mail/EmailManager";

const Home = () => {


    return (
        <Container maxWidth={"xl"}>
            <EmailManager/>
        </Container>
    );
};

export default Home;